var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudsLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 370.732,
    height: 280.672,
    viewBox: "0 0 370.732 280.672",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002415"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 442",
    cx: 206.351,
    cy: 177.497,
    r: 103.175,
    fill: "#E7F5F8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 443",
    cx: 103.175,
    cy: 151.266,
    r: 103.175,
    fill: "#E7F5F8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 444",
    cx: 244.823,
    cy: 103.175,
    r: 103.175,
    fill: "#E7F5F8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 445",
    cx: 307.778,
    cy: 143.396,
    r: 62.9545,
    fill: "#E7F5F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudsLeft);
export default __webpack_public_path__ + "static/media/clouds-left.885196445d55d483a4b8b941e37fec52.svg";
export { ForwardRef as ReactComponent };